import React, { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface EditPostModalProps {
  isOpen: boolean
  onClose: () => void
  onSave: (content: string) => Promise<void>
  initialContent: string
  postId: string
}

export function EditPostModal({
  isOpen,
  onClose,
  onSave,
  initialContent,
  postId,
}: EditPostModalProps) {
  const [content, setContent] = useState(initialContent)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setContent(initialContent)
    }
  }, [isOpen, initialContent])

  if (!isOpen) return null

  async function handleSave() {
    if (content.trim().length < 10) {
      alert('O conteúdo deve ter pelo menos 10 caracteres')
      return
    }

    setIsSubmitting(true)
    try {
      await onSave(content)
      onClose()
    } catch (error) {
      // Error is handled by parent
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-2xl mx-4">
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h2 className="text-xl font-semibold text-card-foreground">
            Editar Post
          </h2>
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="text-muted-foreground hover:text-foreground"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-4">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            disabled={isSubmitting}
            className="w-full h-64 px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-ring bg-background text-foreground resize-none"
            placeholder="Escreva o conteúdo do post..."
          />
          <p className="mt-2 text-sm text-muted-foreground">
            Mínimo de 10 caracteres. Atual: {content.trim().length}
          </p>
        </div>

        <div className="flex justify-end gap-2 p-4 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSave}
            disabled={isSubmitting || content.trim().length < 10}
          >
            {isSubmitting ? 'Salvando...' : 'Salvar'}
          </Button>
        </div>
      </div>
    </div>
  )
}
